import { DispatchObject } from '@/models/globalModels';

import * as t from '../types';

export const doActiveLayout = (isActive: boolean) => (dispatch: DispatchObject<boolean>) => {
  dispatch({
    type: t.ACTIVE_LAYOUT,
    payload: isActive,
  });
};

export const doActiveLayoutItem = (layoutItmeKey: string) => (dispatch: DispatchObject<string>) => {
  dispatch({
    type: t.ACTIVE_ITEM,
    payload: layoutItmeKey,
  });
};
